import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import upms from '../store/upms/upms';
import app from '../store/app/app';
//公共模块

//菜单管理
import menu from './system/sys/menu';
//角色管理
import role from './system/sys/role';
//部门管理
import org from './system/sys/org';
//用户
import user from './system/sys/user';
//岗位
import post from './system/sys/post';
//字典
import dict from './system/sys/dict';
//应用管理
import application from './system/sys/application';

//登录日志
import logininfor from '../store/system/log/logininfor';
//操作
import operlog from '../store/system/log/operlog';
//以上为系统管理模块模块

//角色管理
import logisticsRole from './logistics/sys/role';
//部门管理
import logisticsOrg from './logistics/sys/org';
//用户
import logisticsUser from './logistics/sys/user';
//岗位
import logisticsPost from './logistics/sys/post';
//字典
import logisticsDict from './logistics/sys/dict';
//日志
import logisticsOperLog from './logistics/log/operlog';
//车辆类型
import logisticsVehicleType from '../store/logistics/information/vehicleType';
import logisticsProject from '../store/logistics/information/project';
import logisticsProjectSelectOrg from '../store/logistics/information/projectSelectOrg';
import logisticspProjectSelectOrgUser from '../store/logistics/information/projectSelectOrgUser';
import logisticspInnerVehicleManagement from '../store/logistics/information/innerVehicleManagement';
import logisticspOutVehicleManagement from '../store/logistics/information/outVehicleManagement';

import logisticspInnerDriverManagement from '../store/logistics/information/innerDriverManagement';
import logisticspOutDriverManagement from '../store/logistics/information/outDriverManagement';
import logisticspTransportRoute from '../store/logistics/information/transportRoute';
import logisticspRouteAudit from '../store/logistics/information/routeAudit';
import logisticspRouteRiskManagement from '../store/logistics/information/routeRiskManagement';
import logisticspDriverCarBind from '../store/logistics/information/driverCarBind';

import logisticspDriverCarBindOut from '../store/logistics/information/driverCarBindOut';
import logisticspRouteTransportCapacity from '../store/logistics/businessManagement/routeTransportCapacity';
import logisticspRouteCarAndDriver from '../store/logistics/information/routeCarAndDriver';

import logisticspDriverVehicleBind from '../store/logistics/information/driverVehicleBind';
import logisticspDriverVehicleBindSelect from '../store/logistics/information/driverVehicleBindSelect';

import driverCarBindSelect from '../store/logistics/information/driverCarBindSelect';
import driverCarBindSelectOut from '../store/logistics/information/driverCarBindSelectOut';
import vehicleIdentificationReminder from '../store/logistics/businessManagement/vehicleIdentificationReminder';
import vehicleIdentificationReminderOut from '../store/logistics/businessManagement/vehicleIdentificationReminderOut';
import logisticsExceptionReport from '../store/logistics/businessManagement/exceptionReport';

import logisticsCarTime from '../store/logistics/operationManagement/carTime';
import logisticsCarTimeOut from '../store/logistics/operationManagement/carTimeOut';

import logisticsDriverTime from '../store/logistics/operationManagement/driverTime';
import logisticsDriverTimeOut from '../store/logistics/operationManagement/driverTimeOut';

// 运单报销
import logisticsWaybillReimburse from '../store/logistics/financialManagement/waybillReimburse';
import logisticsCompanyWaybillReimburse from '../store/logistics/financialManagement/companyWaybillReimburse';
import logisticsTemporaryWaybillReimburse from '../store/logistics/financialManagement/temporaryWaybillReimburse';
import logisticsAccount from '../store/logistics/financialManagement/account';

//财务统计
import logisticsProjectReceivable from '../store/logistics/financialManagement/projectReceivable';
import logisticsCustomerReceivable from '../store/logistics/financialManagement/customerReceivable';
import logisticsFinanciaChat from '../store/logistics/financiaChat';
import logisticsCompanyFinanciaChat from '../store/logistics/financiaChat/company';
import logisticsTemporaryFinanciaChat from '../store/logistics/financiaChat/temporary';

//路线财务表
import logisticsFinanceRouteData from '../store/logistics/financialManagement/financeRouteData';
import logisticsDriverSelectUser from '../store/logistics/information/logisticsDriverSelectUser';

import logisticspOrder from '../store/logistics/businessManagement/order';
import logisticspOrderChat from '../store/logistics/businessManagement/orderChat';
import logisticspCancelOrder from '../store/logistics/businessManagement/cancelOrder';
import logisticspOrderScheduling from '../store/logistics/businessManagement/orderScheduling';
import logisticspDispatchNew from '../store/logistics/businessManagement/dispatchNew';
import logisticsWayBill from '../store/logistics/businessManagement/waybill';
import logisticsOvertimeWaybill from '../store/logistics/businessManagement/overtimeWaybill';
import logisticsWaybillModify from '../store/logistics/businessManagement/waybillModify';
import driverReminder from '../store/logistics/businessManagement/driverReminder';
import driverReminderOut from '../store/logistics/businessManagement/driverReminderOut';

import logisticsDriverStatistics from '../store/logistics/operationManagement/driverStatistics';
import logisticsDriverStatisticsOut from '../store/logistics/operationManagement/driverStatisticsOut';
import logisticsMileageData from '../store/logistics/operationManagement/mileageData';
import logisticsClientManagement from '../store/logistics/information/clientManagement';
import logisticsClientGoods from '../store/logistics/information/clientGoods';
import home from '../store/home/home.js';
import logisticspRouteTransportationAnalysis from '../store/logistics/operationManagement/routeTransportationAnalysis';
//车辆违章
import logisticsDriverError from '../store/logistics/businessManagement/driverError';
import logisticsDriverErrorSelect from '../store/logistics/businessManagement/logisticsDriverErrorSelect';
import logisticsTemporaryDispatchPay from '../store/logistics/dynamicTask/temporaryDispatchPay';



//人车绑定关系
import logisticsRouteVehiclePersonBinding from '../store/logistics/information/routeVehiclePersonBinding';

//仓库管理
import logisticsWarehouse from '../store/logistics/information/warehouse';
//轮胎管理
import logisticsTire from '../store/logistics/tire/tire';
import logisticsTireLedger from '../store/logistics/tire/tireLedger';
import logisticsTireLedgerCheckBox from '../store/logistics/tire/tireLedgerCheckBox';
import logisticsTireCarRadio from '../store/logistics/tire/carRadio';

//天气管理
import logisticsWeather from '../store/logistics/information/weather';

// 动态任务
import logisticsTemporaryDispatch from '../store/logistics/dynamicTask/temporaryDispatch';
//员工关怀
import logisticsSuggestion from '../store/logistics/operationManagement/suggestion';

//车辆里程统计
import logisticsVehicleMileage from '../store/logistics/operationManagement/vehicleMileage';
import logisticsScouted from '../store/logistics/gis/scouted';

//途灵
//角色管理
import platformRole from './platform/sys/role';
//部门管理
import platformOrg from './platform/sys/org';
//用户
import platformUser from './platform/sys/user';
//岗位
import platformPost from './platform/sys/post';
//字典
import platformDict from './platform/sys/dict';

//资料管理
import platformRealNameAuthenticationCompany from './platform/information/realNameAuthenticationCompany';
import platformRealNameAuthenticationPerson from './platform/information/realNameAuthenticationPerson';
import platformRealNameAuthentication from './platform/information/realNameAuthentication';
import platformDriverCertification from './platform/information/driverCertification';
import platformVehicleCertification from './platform/information/vehicleCertification';
import platformCapacityCertification from './platform/information/capacityCertification';

import platformSupply from './platform/supply/supply';

//车辆监管
//角色管理
import superviseRole from './supervise/sys/role';
//部门管理
import superviseOrg from './supervise/sys/org';
//用户
import superviseUser from './supervise/sys/user';
//岗位
import supervisePost from './supervise/sys/post';
//字典
import superviseDict from './supervise/sys/dict';
//首页
import superviseHome from './supervise/home/home.js';
//多车跟踪
import superviseMoreCar from './supervise/moreCar/moreCar';

//===app管理模块====
import mobileAppVersion from './mobile/app/version';
import mobileAppPermission from './mobile/app/permission';
import mobileApprRolePermissions from './mobile/app/rolePermissions';

//角色管理
import mobileRole from './mobile/sys/role';
//用户
import mobileUser from './mobile/sys/user';

//字典
import mobileDict from './mobile/sys/dict';
import mobileOrg from './mobile/sys/org';
import mobilePost from './mobile/sys/post';

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    upms,
    home,
    //系统管理应用
    role,
    menu,
    org,
    user,
    post,
    dict,
    application,
    logininfor,
    operlog,

    //昶途云
    logisticsRole,
    logisticsOrg,
    logisticsUser,
    logisticsPost,
    logisticsDict,
    logisticsOperLog,
    logisticsVehicleType,
    logisticsProject,
    logisticsProjectSelectOrg,
    logisticspProjectSelectOrgUser,
    logisticspInnerVehicleManagement,
    logisticspOutVehicleManagement,
    logisticspInnerDriverManagement,
    logisticspOutDriverManagement,
    logisticspTransportRoute,
    logisticspRouteAudit,
    logisticspRouteRiskManagement,
    logisticspDriverCarBind,
    logisticspDriverCarBindOut,
    driverCarBindSelect,
    driverCarBindSelectOut,
    vehicleIdentificationReminder,
    vehicleIdentificationReminderOut,
    logisticsCarTime,
    logisticsCarTimeOut,
    logisticsDriverTime,
    logisticsDriverTimeOut,
    logisticsAccount,
    logisticspOrder,
    logisticspOrderChat,
    logisticspCancelOrder,
    logisticspOrderScheduling,
    logisticspDispatchNew,
    logisticsWayBill,
    logisticsOvertimeWaybill,
    logisticsDriverStatistics,
    logisticsDriverStatisticsOut,
    logisticsMileageData,
    logisticsDriverError,
    logisticsDriverErrorSelect,
    logisticsClientManagement,
    logisticsClientGoods,
    logisticsWaybillModify,
    driverReminder,
    driverReminderOut,
    logisticsWarehouse,
    logisticsTire,
    logisticsTireLedger,
    logisticsTireLedgerCheckBox,
    logisticsWeather,
    logisticsTemporaryDispatch,
    logisticsTireCarRadio,
    logisticsExceptionReport,
    logisticsWaybillReimburse,
    logisticsCompanyWaybillReimburse,
    logisticsTemporaryWaybillReimburse,
    logisticsProjectReceivable,
    logisticsCustomerReceivable,
    logisticspRouteTransportCapacity,
    logisticspRouteCarAndDriver,
    logisticspDriverVehicleBind,
    logisticspDriverVehicleBindSelect,
    logisticspRouteTransportationAnalysis,
    logisticsFinanciaChat,
    logisticsCompanyFinanciaChat,
    logisticsTemporaryFinanciaChat,
    logisticsSuggestion,
    logisticsVehicleMileage,
    logisticsFinanceRouteData,
    logisticsDriverSelectUser,
    logisticsScouted,
    logisticsRouteVehiclePersonBinding,
    logisticsTemporaryDispatchPay,

    //途灵物流
    platformRole,
    platformOrg,
    platformUser,
    platformPost,
    platformDict,
    platformRealNameAuthenticationCompany,
    platformRealNameAuthenticationPerson,
    platformRealNameAuthentication,
    platformDriverCertification,
    platformVehicleCertification,
    platformCapacityCertification,
    platformSupply,
    //车辆监管平台
    superviseRole,
    superviseOrg,
    superviseUser,
    supervisePost,
    superviseDict,
    superviseHome,
    superviseMoreCar,

    //app管理
    mobileAppVersion,
    mobileAppPermission,
    mobileApprRolePermissions,
    mobileRole,
    mobileUser,
    mobileDict,
    mobileOrg,
    mobilePost,
  },
});
